<template>
<div class="error-container" v-if="error">
  {{ error.message }}
  <ul v-if="error.errors.length > 1">
    <li
    v-for="detailedError in error.errors"
    :key="detailedError.message"
    >
      {{ detailedError.message }}
    </li>
  </ul>
  <span v-else-if="error.errors.length == 1">
    {{ error.errors[0].message }}
  </span>
  <span>
    <slot></slot>
  </span>
</div>
</template>

<script>
export default {
  name: 'ErrorContainer',
  props: {
    error: {
      required: false,
      type: Error
    }
  }
}
</script>

<style lang="scss" scoped>
  .error-container {
    color: red;
    font-size: 0.8rem;
  }
  .error-container li {
    margin-left: -24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ErrorContainer.vue